import { T } from 'gt-react';
import { Link } from '@tanstack/react-router';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { isWorkflowRunHref } from './notificationLinks';
import { NotificationViewRunButton } from './NotificationViewRunButton';

interface Props {
  href: string;
  onClick?: () => void;
}

/**
 * Opens the record a notification refers to. Workflow-run hrefs get the
 * dedicated View Run control; everything else uses a generic Open button.
 */
export function NotificationRecordOpenButton({ href, onClick }: Props) {
  if (isWorkflowRunHref(href)) {
    return <NotificationViewRunButton href={href} onClick={onClick} />;
  }

  return (
    <Button asChild variant="outline" size="sm">
      <Link to={href} onClick={onClick}>
        <ArrowSquareOutIcon />
        <T context="button that opens the record a notification refers to">
          Open
        </T>
      </Link>
    </Button>
  );
}
